module.exports = __webpack_public_path__ + "img/sfmd1.0c9760da.jpg";